import { format } from "@hejdoktor/resx-compiler"
export { format }
import { getLocale } from "@hejdoktor/resx-compiler"

import { R as _da } from "./AddChildrenModal.da.resx"
import { R as _en } from "./AddChildrenModal.en.resx"
import { R as _nb } from "./AddChildrenModal.nb.resx"

type Translations = {
	"title": string,
	"subtitle": string,
	"buttonCreateManually": string,
	"buttonInviteManually": string,
}

const R = new Proxy({}, {
	get(target, name: keyof Translations, receiver) {
		if(process.env.enforcedLocale === "da" || (!process.env.enforcedLocale && getLocale("da") === "da")) {
			return _da[name] ?? name
		}

if(process.env.enforcedLocale === "en" || (!process.env.enforcedLocale && getLocale("da") === "en")) {
			return _en[name] ?? name
		}

if(process.env.enforcedLocale === "nb" || (!process.env.enforcedLocale && getLocale("da") === "nb")) {
			return _nb[name] ?? name
		}

		return name
	},
}) as Translations

export { R }